/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoAnalyticsModelsWidgetListItem,
    MelcoAnalyticsModelsWidgetListItemFromJSON,
    MelcoAnalyticsModelsWidgetListItemFromJSONTyped,
    MelcoAnalyticsModelsWidgetListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem
 */
export interface MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem {
    /**
     * 
     * @type {Array<MelcoAnalyticsModelsWidgetListItem>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem
     */
    list: Array<MelcoAnalyticsModelsWidgetListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItemFromJSON(json: any): MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem {
    return MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoAnalyticsModelsWidgetListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItemToJSON(value?: MelcoModelsGenericList1MelcoAnalyticsModelsWidgetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoAnalyticsModelsWidgetListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


